import React, { memo, useContext, useMemo, useRef, useState } from 'react';
import { usePriceChange } from '../helpers';
import { useAppDispatch, useAppSelector } from '../../../redux/app';
import { TradeContext } from '../context/TradeContextProvider';
import { setPayload } from '../../../redux/reducer/payload';
import { makeBidAskBySymbolSelector } from '../../../redux/selector';
import cn from '../../../utilities/cn';
import { DirectionIcons } from '@vt/vt-ui';

const InputPrice = memo(({ validate, className, defaultValue, editBidAsk }) => {
  const priceRef = useRef(null);
  const [isFocused, setIsFocused] = useState(false);
  const data = useAppSelector((state) => state.payload?.payload);
  const { instrumentInfo } = useContext(TradeContext);
  const getBidAsk = useMemo(makeBidAskBySymbolSelector, []);
  const bidAsk = useAppSelector((state) => getBidAsk(state, instrumentInfo?.symbol ?? ''));
  const dispatch = useAppDispatch();

  const handlePrice = (type) => {
    const price = usePriceChange({
      type: type,
      price_order: data.price_order,
      ask: editBidAsk ? editBidAsk.ask : bidAsk?.ask,
      digits: editBidAsk ? editBidAsk.digit : instrumentInfo?.digit
    });
    dispatch(
      setPayload({
        ...data,
        price_order: price
      })
    );
  };

  const validatePrice = (key) => {
    let price_order;
    switch (key) {
      case 2:
        price_order = editBidAsk ? editBidAsk.ask : bidAsk?.ask;
        break;
      case 3:
        price_order = editBidAsk ? editBidAsk.bid : bidAsk?.bid;
        break;
      case 4:
        price_order = editBidAsk ? editBidAsk.ask : bidAsk?.ask;
        break;
      case 5:
        price_order = editBidAsk ? editBidAsk.bid : bidAsk?.bid;
        break;
      case 6:
        price_order = editBidAsk ? editBidAsk.ask : bidAsk?.ask;
        break;
      case 7:
        price_order = editBidAsk ? editBidAsk.bid : bidAsk?.bid;
        break;
      default:
        break;
    }
    return dispatch(
      setPayload({
        ...data,
        price_order: price_order ?? 0
      })
    );
  };

  return (
    <div className={cn("relative border hover:border-[#0FEF9E] rounded-lg mt-2", isFocused ? "border-[#0FEF9E]" : "border-[#4B4B4B]")}>
      <input
        onChange={({ target: { value } }) => {
          if (value !== '') {
            if (value.startsWith('-')) {
              priceRef.current.value = data.price_order;
            } else {
              dispatch(
                setPayload({
                  ...data,
                  price_order: +value
                })
              );
            }
          } else {
            dispatch(
              setPayload({
                ...data,
                price_order: 0
              })
            );
          }
        }}
        type="number"
        ref={priceRef}
        value={data.price_order <= 0 ? '' : data.price_order}
        placeholder="No Set"
        className="input-left-lotsize p-[10px] !w-[calc(100%-24px)]"
        style={{ caretColor: isFocused ? '#0FEF9E' : 'auto' }}
        onMouseDown={() => {
          if (!defaultValue) {
            if (+data.price_order === 0) {
              validatePrice(validate);
            }
          }
        }}
        onFocus={() => setIsFocused(true)}
        onBlur={() => setIsFocused(false)}
      />
      <div className="absolute right-0 top-0 bottom-0 flex w-6 flex-col rounded-r-lg border-l border-[#4b4b4b] hover:border-[#0FEF9E]">
        <button
          type="button"
          className={cn(
            'vt-flex group hover:bg-[#0FEF9E] flex-1 items-center justify-center rounded-tr-md border-b border-[#4b4b4b] transition-colors',
          )}
          onClick={() => handlePrice('inc')}
        >
          <DirectionIcons.Up className="h-4 w-4 stroke-neutral-400 fill-neutral-400 group-hover:stroke-[#151515] group-hover:fill-[#151515] transition-colors" />
        </button>
        <button
          type="button"
          className={cn(
            'vt-flex group flex-1 hover:bg-[#0FEF9E] hover:border-[#0FEF9E] items-center justify-center rounded-br-md transition-colors',
          )}
          onClick={() => handlePrice('dec')}
        >
          <DirectionIcons.Down className="h-4 w-4 stroke-neutral-400 fill-neutral-400 group-hover:stroke-[#151515] group-hover:fill-[#151515] transition-colors" />
        </button>
      </div>
    </div>
  )
});

InputPrice.displayName = 'InputPrice';

export default InputPrice;
